export const getRoute = (route: string, baseRoute?: string): string => {
    baseRoute = baseRoute || '';
    return `${baseRoute}${route}`;
};

export const getAllRoutes = (baseRoute?: string): { [key: string]: string } => {
    return {
        ROOT: getRoute('', baseRoute),
        DEALERSHIP_SELECTOR: getRoute('/dealership-selector', baseRoute),
        NO_DEALERSHIP_ACCESS: getRoute('/no-dealership-access', baseRoute),
        ROLE_ASSUMPTION: getRoute('/role-assumption', baseRoute),
        APP_ERROR: getRoute('/app-error', baseRoute),
        DEAL_SETUP: getRoute('/deal-setup', baseRoute)
    };
};
